<template>
  <f7-app :params="f7params" :class="{ 'bg-transparent': cameraOpened, 'bg-white': !cameraOpened}">
    <f7-appbar>
      <div class="left">
        <f7-button small panel-toggle="left" class="display-flex" icon-f7="bars"></f7-button>
        <a href="/">
          <img src="static/img/logo.png" style="max-height: 1.6rem;"  />
        </a>
        <f7-button
            v-if="rutaCalendario"
            style="margin-left: 20px;color: #22355b;"
            fill
            icon-f7="clock"
            color="orange"
            popup-open=".popup-fichaje"
            @click="fichajeRango = false"
          > Fichar </f7-button>
        <f7-button
            v-if="rutaCalendario"
            style="margin-left: 20px;color: #22355b;"
            fill
            icon-f7="clock"
            color="orange"
            popup-open=".popup-fichaje"
            @click="fichajeRango = true"
          > Fichar Rango</f7-button>
      </div>

      <div class="right">
        <f7-button v-if="target != 'cordova'" icon-f7="search" @click="$refs.inputBusquedaGlobal.focus()"></f7-button>
        <input v-if="target != 'cordova'" ref="inputBusquedaGlobal" class="input-busqueda-global" v-model="textoBusquedaGlobal" @keyup.enter="search" type="text"/>
        <r-aviso-festivos></r-aviso-festivos>
        <r-alertas-bell></r-alertas-bell>
        <f7-button
          small
          class="display-flex"
          icon-f7="lightbulb"
          popup-open=".popup-sugerencia"
        >Sugerencia de Mejora</f7-button>
        <r-ayuda-global></r-ayuda-global>
      </div>
      <f7-popup ref="popupBusquedaGlobal" class="popup-sugerencia" swipe-to-close>
        <f7-page>
          <f7-navbar title="Búsqueda global">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <div>
                <h3 class="global-search-title">Clientes</h3>
                <ul class="search-result-list">
                  <li v-for="(cliente,i) in busquedaGlobal.clientes" :key="'cliente'+i" @click="navega('cliente', cliente)">[{{cliente.codigo}}] {{cliente.razonSocial}} - {{cliente.activo ? 'Activo' : 'No activo'}}</li>
                </ul>
              </div>
              <div>
                <h3 class="global-search-title">Ofertas</h3>
                <ul class="search-result-list">
                  <li v-for="(oferta,i) in busquedaGlobal.ofertas" :key="'oferta'+i" @click="navega('oferta', oferta)">{{oferta.numero}} - [{{oferta.cliente.codigo}}] ({{oferta.cliente.razonSocial}}) - {{oferta.fechaOferta | dateParse | dateFormat('DD/MM/YYYY') }} - {{oferta.totalSinIVASinTasasConDescuentoConTerceros | numberParse | numberFormat(2)}} € </li>
                </ul>
              </div>
              <div>
                <h3 class="global-search-title">Pedidos</h3>
                <ul class="search-result-list">
                  <li v-for="(pedido,i) in busquedaGlobal.pedidos" :key="'oferta'+i" @click="navega('pedido', pedido)">{{pedido.numero}} - [{{pedido.cliente.codigo}}] ({{pedido.cliente.razonSocial}}) - {{pedido.fechaContratacion | dateParse | dateFormat('DD/MM/YYYY') }} - {{pedido.totalSinIVASinTasasConDescuentoConTerceros | numberParse | numberFormat(2)}} €</li>
                </ul>
              </div>
            </f7-card-content>
          </f7-card>
        </f7-page>
      </f7-popup>
      <f7-popup ref="popupSugerencia" class="popup-sugerencia" swipe-to-close>
        <f7-page>
          <f7-navbar title="Sugerencia de Mejora">
            <f7-nav-right></f7-nav-right>
          </f7-navbar>

          <!-- <div style="height: 100%" class="display-flex justify-content-center align-items-center"> -->
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <textarea
                floating-label
                placeholder="Sugerencia"
                name="sugerenciaMejora"
                ref="sugerenciaMejora"
                class="padding-left margin-right"
              ></textarea>
            </f7-card-content>
            <f7-button
              fill
              icon-f7="paperplane"
              text="Enviar"
              class="margin-left display-flex"
              color="blue"
              @click="sendSugerencia"
            ></f7-button>
          </f7-card>
          <!-- </div> -->
        </f7-page>
      </f7-popup>

      <f7-popup :close-by-backdrop-click="false" ref="popupFichaje" class="popup-fichaje" @popup:opened="prepararFichaje" @popup:closed="newFichaje = undefined; lastFichaje = undefined; usernameFichajeNoid = null">
        <f7-page>
          <f7-navbar>
            <f7-nav-left v-if="newFichaje && newFichaje.fechaHora">
              <f7-link @click="guardarFichaje">Guardar</f7-link>
            </f7-nav-left>
            <f7-nav-title>Fichaje</f7-nav-title>
            <f7-nav-right></f7-nav-right>
          </f7-navbar>
          <f7-card v-if="Utils.getUser() && Utils.getUser().username == 'NOID'" class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <f7-list class="list-form no-hairlines">
                <f7-list-input
                  label="Empleado destino"
                  floating-label
                  type="text"
                  placeholder="Introduce el username del empleado"
                  :value="usernameFichajeNoid"
                  @input="usernameFichajeNoid = $event.target.value"
                  clear-button
                ></f7-list-input>
              </f7-list>
            </f7-card-content>
          </f7-card>
          <f7-card class="elevation-3 padding-vertical-half padding-right">
            <f7-card-content>
              <table width="100%">
                <tr v-if="lastFichaje">
                  <template v-if="!fichajeRango">
                    <td><h3 class="global-search-title">Anterior</h3></td>
                    <td>{{lastFichaje.tipoFichaje}}</td>
                    <td>{{lastFichaje.fechaHora | dateParse | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                    <td>{{lastFichaje.comentario}}</td>
                    <td style="text-align: right;">{{lastFichaje.tipoFichaje=='SALIDA'?DateUtils.getDurationInHoursAndMinutes(lastFichaje.duracion):''}}</td>
                  </template>
                  <template v-else>
                    <td><h3 class="global-search-title">Entrada</h3></td>
                    <td>{{lastFichaje.tipoFichaje}}</td>
                    <td>
                      <!-- :value="newFichaje.fechaHora" -->
                      <f7-list-input
                        v-if="lastFichaje && lastFichaje.fechaHora"
                        v-bind="{ ...$attrs, ...$props }"
                        v-on="$listeners"
                        style="list-style-type: none;"
                        type="datetime-local"
                        :value="lastFichaje.fechaHora"
                        @input="changeDate($event, 'lastFichaje')"
                        :min="getMinDate()"
                      ></f7-list-input>
                    </td>
                    <td>
                      <input class="input-fichaje" v-model="lastFichaje.comentario" type="text"/>
                    </td>
                  </template>
                </tr>
                <tr v-if="newFichaje">
                  <td v-if="!fichajeRango" class="global-search-title"><h3>Nuevo</h3></td>
                  <td v-else class="global-search-title"><h3>Salida</h3></td>
                  <td>{{newFichaje.tipoFichaje}}</td>
                  <td>
                    <!-- :value="newFichaje.fechaHora" -->
                    <f7-list-input
                      v-if="newFichaje && newFichaje.fechaHora"
                      v-bind="{...$attrs,...$props}"
                      v-on="$listeners"
                      style="list-style-type: none;"
                      type="datetime-local"
                      :value="newFichaje.fechaHora"
                      @input="changeDate($event, 'newFichaje')"
                      :min="getMinDate()"
                    ></f7-list-input>
                  </td>
                  <td>
                    <input class="input-fichaje" v-model="newFichaje.comentario" type="text"/>
                  </td>
                  <td style="text-align: right;">
                    {{ newFichaje.tipoFichaje=='SALIDA'? getDuracion() : ''}}
                  </td>
                </tr>
              </table>
            </f7-card-content>
          </f7-card>
        </f7-page>
      </f7-popup>

    </f7-appbar>
    <!-- Left panel with cover effect-->
    <f7-panel v-show="!cameraOpened" left cover :visibleBreakpoint="1024">
      <f7-view class="view-left" :init="false"></f7-view>
    </f7-panel>

    <!-- Your main view, should have "view-main" class -->
    <f7-view v-show="!cameraOpened" main class="safe-areas" url="/" :init="false"></f7-view>
    <agent-chat-widget v-roles="['ADMIN', 'DTYCAL']" :visible="!cameraOpened"></agent-chat-widget>
    <!-- Overlay para capturar gestos de pinch cuando la cámara está abierta -->
    <div v-show="cameraOpened && cameraPhoto" class="camera-pinch-overlay" ref="cameraPinchOverlay"></div>
    <div v-show="cameraOpened" class="controlesCamara">
      <f7-link @click="cerrarCamara" icon-f7="xmark_circle_fill"></f7-link>
      <!-- <span v-show="cameraPhoto" class="zoom-level">{{ zoomLevel }}x</span> -->
      <f7-link v-show="cameraPhoto" @click="toggleFlash" :icon-f7="flashEnabled ? 'bolt_fill' : 'bolt_slash'" :color="flashEnabled ? 'yellow' : 'white'" title="Flash"></f7-link>
      <f7-link v-show="cameraPhoto" ref="botonFoto" icon-f7="camera"></f7-link>
      <f7-link v-show="cameraPhoto" ref="botonFotoYOtra" icon-f7="camera_on_rectangle"></f7-link>
      <f7-link v-show="!cameraRecording && !cameraPhoto"  @click="startVideo()" icon-f7="videocam"></f7-link>
      <f7-link v-show="cameraRecording && !cameraPhoto" ref="botonVideo" icon-f7="stop_circle"></f7-link>
    </div>

    <div v-if="aiNotifications.length" class="ai-notif-stack">
      <div
        v-for="notif in aiNotifications"
        :key="notif.id"
        class="ai-notif"
        :class="'ai-notif--' + notif.type"
      >
        <i class="material-icons ai-notif-icon">{{ notif.type === 'ok' ? 'check_circle' : 'error' }}</i>
        <div class="ai-notif-body">
          <div class="ai-notif-title">{{ notif.title }}<span v-if="notif.hora" class="ai-notif-time">{{ notif.hora }}</span></div>
          <div class="ai-notif-text">{{ notif.text }}</div>
        </div>
        <button class="ai-notif-close" @click="_dismissAiNotification(notif.id)" aria-label="Cerrar">
          <i class="material-icons">close</i>
        </button>
      </div>
    </div>
  </f7-app>
</template>
<style>
  @import '../css/medium-editor-tables.css';
  /* .controlesCamara {
  position: absolute;
  bottom: 20px;
  left: 250px;
  display: flex;
  z-index: 12000;
  } */
  .controlesCamara {
    justify-content: center;
    align-items: center;
    height: 80px;
    width: 100vw;
    position: absolute;
    bottom: 15px;
    left: 0;
    background: rgba(255, 255, 255, 0.445);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    z-index: 12000;
    pointer-events: none;
  }
  .controlesCamara .link, .controlesCamara .icon{
    font-size: 40px !important;
    margin: 20px;
    pointer-events: auto;
  }
  .zoom-level {
    color: white;
    font-weight: bold;
    min-width: 40px;
    text-align: center;
    font-size: 14px;
    pointer-events: none;
  }
  .width-70 {
    width: 70% !important;
  }

  .overflow-auto {
    overflow: auto;
  }
  .bg-transparent {
    background: transparent;
  }
  .bg-white {
    background: white;
  }
  /* Estilos para pinch-to-zoom */
  .f7-app {
    touch-action: none;
  }
  .camera-pinch-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 11999;
    background: transparent;
    touch-action: none;
  }
</style>
<style scoped>
app textarea {
  border: none;
  width: 100%;
  min-height: 200px;
}
.justify-left {
  justify-content: initial;
}
.appbar {
  border-bottom: 1px solid #aaa;
}
.global-search-title[data-v-6c0a0fc1] {
  color: lightblue;
  margin: 0;
  padding-left: 0.5em;
}
.search-result-list {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 134px;
  overflow: auto;
}
.search-result-list li {
  padding: 0.2em 1em;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-result-list li:hover {
  background: lightblue;
  border-radius: 0.5em;
  cursor: pointer;
}
.input-fichaje {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 0.5em;
  padding: 0.5em;
}
</style>
<script>
import cordovaApp from "../js/cordova-app.js";
import { routes, routesLeft } from "../js/routes.js";
import Usuario from "./../js/db/Usuario.js";
import UsuarioActualizado from "./../js/usuarioActualizado.js";
import { alAbrirSesion, alCerrarSesion, instalarRecogidaDeCancelaciones } from "./../js/utils/sesionDePeticiones.js";
import Property from "./../js/db/Property.js";
import Fichaje from "./../js/db/Fichaje.js";
import Global from "./../js/db/Global.js";
import Sugerencia from "./../js/db/Sugerencia.js";
import Notificacion from "./../js/db/Notificacion.js";
import InspeccionOffline from "./../js/db/InspeccionOffline.js";
import DatabaseModelOffline from "./../js/db/DatabaseModelOffline";
import LokiFsAdapter from "./../js/LokiFsAdapter.js";
import FileUtils from '../js/FileUtils';
import Utils from '../js/Utils';
import DateUtils from "../js/DateUtils";
import Flash from '../js/FlashUtils';
import { EventBus } from "../js/EventBus";
import AiDocumentsEvents from "./../js/db/AiDocumentsEvents.js";
import EventosErrorEvents from "./../js/db/EventosErrorEvents.js";
import SseHub from "./../js/db/SseHub.js";
import preloaderDeLaSesion from "./../js/utils/preloaderDeLaSesion.js";
import AgentChatWidget from './agent-chat-widget.vue';
import RAlertasBell from './r-alertas-bell.vue';
import RAvisoFestivos from './r-aviso-festivos.vue';
import RAyudaGlobal from './rAyudaGlobal.vue';
import * as nominatim from 'nominatim-client';
import moment, { min } from 'moment';
import piexif from 'piexifjs';
// Constante para el zoom mínimo de la cámara
const CAMERA_MIN_ZOOM = 0.9;

export default {
  components: {
    AgentChatWidget,
    'r-alertas-bell': RAlertasBell,
    'r-aviso-festivos': RAvisoFestivos,
    'r-ayuda-global': RAyudaGlobal,
  },
  data() {
    return {
      cameraOpened: false,
      cameraPhoto: false,
      cameraRecording: false,
      zoomLevel: 1,
      maxZoom: 1,
      minZoom: CAMERA_MIN_ZOOM,
      flashEnabled: false,
      // Estado para pinch-to-zoom
      pinchStartDistance: 0,
      pinchStartZoom: 1,
      isPinching: false,
      // Referencias a handlers para poder removerlos después
      _touchStartHandler: null,
      _touchMoveHandler: null,
      _touchEndHandler: null,
      // Gestión de cámaras
      availableCameras: [],
      currentCameraIndex: 0,
      lastCameraSwitch: 0, // Para evitar cambios muy rápidos
      cameraPhotoOptions: { camera: "back", tapFocus: true, storeToFile: true, tapPhoto: false, disableExifHeaderStripping: true, toBack: true },
      lastFotoCallback: null,
      lastFotoExtraParams: null,
      target: process.env.TARGET,
      textoBusquedaGlobal: "",
      busquedaGlobal: {clientes: [], ofertas: [], pedidos: []},
      aiNotifications: [],
      lastFichaje: null,
      newFichaje: null,
      usernameFichajeNoid: null,
      Utils,
      DateUtils,
      nominatim,
      fichajeRango: null,
      // Framework7 Parameters
      f7params: {
        id: "com.simecal.admin", // App bundle ID
        name: "Simecal", // App name
        theme: "aurora", // Automatic theme detection
        // App root data
        data: function() {
          return {
            URL_API: "",
            user: {},
            appDataPath:
              typeof eapp != "undefined" ? eapp.getPath("userData") : (typeof cordova != "undefined" && typeof cordova.file != "undefined" ? cordova.file.dataDirectory + 'files' : "")
          };
        },
        methods: {
          checkAuth: function() {
            return this.data.session ? true : false;
          },
          checkPermission: function(pagename) {
            return true;
          },
          startSession: function() {
            var session = localStorage.getItem("session");
            if (typeof session != "undefined" && session) {
              var sessionObj = JSON.parse(session);
              this.data.session = sessionObj;
              this.request.setup({
                headers: {
                  Authorization: "Bearer " + sessionObj.token
                }
              });
              EventBus.$emit("app:auth-ready");
              var user = localStorage.getItem("user");
              var redirect = false;
              if (typeof user == "undefined" || !user) {
                redirect = true;
                this.methods.loadGlobals(redirect);
              } else {
                var properties = localStorage.getItem("properties");
                if (typeof properties == "undefined" || !properties) {
                  this.methods.loadProperties();
                }
                // [#65] Con usuario guardado tampoco se da por bueno sin más: el de localStorage
                // es el de la ÚLTIMA sesión, y un cambio de permisos en el servidor no llegaba
                // nunca porque aquí no se volvía a preguntar. Se refresca siempre; mientras la
                // respuesta no esté, las pantallas que deciden con permisos esperan por esta misma
                // petición (ver `usuarioActualizado.js`), no por el menú persistido.
                UsuarioActualizado.cargar({ forzar: true }).catch(function(e) {
                  // Aquí solo se deja constancia, y a propósito: el token rechazado lo trata
                  // `usuarioActualizado.js`, que es por donde pasan TODOS los que piden el usuario
                  // fresco —cierra la sesión y lleva al login, igual que haría `DatabaseModel` si
                  // esta petición pasara por él—. Repetirlo aquí dejaría dos sitios decidiendo
                  // cuándo se acaba una sesión. Lo que sea un fallo del servidor lo enseña la
                  // barrera de cada pantalla con su reintento. Sin este `catch` sería además una
                  // promesa rechazada sin recoger.
                  console.warn("No se ha podido refrescar el usuario al arrancar", e);
                });
              }
            }
            //TODO: Load user data
          },
          saveSession: function(obj, opciones) {
            this.data.session = obj;
            localStorage.setItem("session", JSON.stringify(obj));
            // [#663] Antes de avisar a nadie: lo que siga en vuelo de la sesión anterior no puede
            // contestar a quien acaba de entrar. Renovar el token de la misma sesión no cuenta.
            alAbrirSesion(opciones);
            EventBus.$emit("app:session:open");
            EventBus.$emit("app:auth-ready");
          },
          removeSession: function() {
            delete this.data.session;
            localStorage.removeItem("session");
            localStorage.removeItem("user");
            // [#65] Y lo que supiéramos del usuario deja de valer: sin esto, el siguiente login en
            // la misma pestaña empezaría dando por bueno el usuario del anterior.
            UsuarioActualizado.olvidar();
            alCerrarSesion();
            EventBus.$emit("app:session:close");
            if (typeof cordova != 'undefined' && cordova && cordova.plugins && cordova.plugins.notification && cordova.plugins.notification.local) {
              cordova.plugins.notification.local.un('trigger', this.methods.onTriggerLocalNotification, this);
              cordova.plugins.notification.local.cancelAll((e) => console.log("CANCELALL", e) );
            }
            // Si la sesión se acaba (logout manual, token expirado, 401 del backend, etc.)
            // siempre debemos enviar al usuario a /login/. Antes esta redirección la hacía
            // solo el callback de 401 de DatabaseModel y se podía perder por race conditions.
            try {
              if (this.views && this.views.main && this.views.main.router) {
                var currentURL = this.views.main.router.currentRoute && this.views.main.router.currentRoute.path;
                if (currentURL && currentURL !== "/login/") {
                  Flash.set("redirectTo", currentURL);
                }
                if (currentURL !== "/login/") {
                  this.views.main.router.navigate("/login/");
                }
              }
            } catch (e) {
              console.warn("removeSession: no se pudo navegar a /login/", e);
            }
          },
          
          onTriggerLocalNotification(event) {
            console.log(event);
            const self = this;

            if (!this.methods.checkInternetConnection()) {
              console.log("No hay conexión a internet");
              if (event) {
                cordova.plugins.notification.local.update({
                  id: event.id,
                  text: "No hay conexión a internet"
                });
                setTimeout(() => {
                  cordova.plugins.notification.local.clear({id: event.id});
                }, 5000);
              }
              return;
            }

            let loginData = localStorage.getItem('loginData');
            if (!loginData) {
              console.log("No hay datos de usuario para logarse");
              if (event) {
                cordova.plugins.notification.local.update({
                  id: event.id,
                  text: "No hay datos de usuario para logarse"
                });
                setTimeout(() => {
                  cordova.plugins.notification.local.clear({id: event.id});
                }, 5000);
              }
              return;
            }
            
            loginData = JSON.parse(loginData);

            if (!loginData || !loginData.username || !loginData.password) {
              console.log("No hay datos de usuario para logarse");
              if (event) {
                cordova.plugins.notification.local.update({
                  id: event.id,
                  text: "No hay datos de usuario para logarse"
                });
                setTimeout(() => {
                  cordova.plugins.notification.local.clear({id: event.id});
                }, 5000);
              }
              return;
            }

            console.log("Autenticamos con los datos de usuario que tenemos");
            if (event) {
              cordova.plugins.notification.local.update({
                  id: event.id,
                  text: "Autenticamos con los datos de usuario que tenemos"
              });
            }
            Usuario.auth(loginData)
            .then(function(loginres) {
              // Es la misma persona reentrando sola con sus credenciales: lo que estuviera
              // esperando sigue siendo suyo.
              self.methods.saveSession({
                token: loginres.access_token
              }, { renovacion: true });
              console.log("Autenticación OK");
              if (event) {
                cordova.plugins.notification.local.update({
                  id: event.id,
                  text: "Autenticación OK"
                });
              }
              let fechaInspeccionHasta = moment.utc(moment().add(-1,"day").endOf("day")).format('yyyy-MM-DDTHH:mm:ss.sssZZ');
              InspeccionOffline.getList({filter: {
                'estado.estado': {'$in':['GENERADO', 'PLANIFICADO']},
                'calificacion': {'$exists': true},
                'guardadoLocal': {'$exists': true},
                'fechaInsp': {$lte:fechaInspeccionHasta}
              }, projection: ['id']}).then(function(res) {
                  let inspecciones = res.list;
                  let errores = 0;
                  let oks = 0;
                  let totales = inspecciones.length;
                  var p = Promise.resolve();
                  if (inspecciones && inspecciones.length) {
                    for (let i = 0; i < inspecciones.length; i++) {
                      p = p.then(_ => new Promise(function(resolve, reject) {
                        console.log("Sincronizando " + (i + 1) + " expedientes de " + totales);
                        if (event) {
                          let porc = Math.round(((i + 1) * 100) / totales );
                          cordova.plugins.notification.local.update({
                            id: event.id,
                            title: 'Sincronización [' + porc + '%]',
                            text: "Sincronizando " + (i + 1) + " expedientes de " + totales,
                            progressBar: { value: porc}
                          });
                        }
                        DatabaseModelOffline.syncUp({ data: [inspecciones[i]] })
                        .then(function() {
                          oks++;
                          resolve();
                        })
                        .catch(function(e) {
                          errores++;
                          resolve();
                        });
                      }));
                    }
                  }
                  p.then((_) => {
                    console.log("Sincronizados " + oks + " expedientes. Errores: " + errores);
                    if (event) {
                      cordova.plugins.notification.local.update({
                        id: event.id,
                        title: 'Sincronización [100%]',
                        text: "Sincronizados " + oks + " expedientes. Errores: " + errores,
                        progressBar: { value: 100 }
                      });
                      setTimeout(() => {
                        cordova.plugins.notification.local.clear({id: event.id});
                      }, 5000);
                    }
                  }).catch(e => reject(e));
                  
              });
            })
            .catch(function(e) {
              console.log("Error al hacer login con los datos de usuario guardados");
              cordova.plugins.notification.local.update({
                id: event.id,
                text: "Error al hacer login con los datos de usuario guardados"
              });
              setTimeout(() => {
                cordova.plugins.notification.local.clear({id: event.id});
              }, 5000);
            });
          },

          checkInternetConnection() {
            return !(!navigator || !navigator.connection || !navigator.connection.type || navigator.connection.type == Connection.NONE);
          },

          getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
          },

          loadProperties: function () {
            Property.getList({ filter: {} }).then(function (res) {
              if (res && res.list) {
                localStorage.setItem('properties', JSON.stringify(res.list));
              } else {
                localStorage.setItem('properties', JSON.stringify([]));
              }
            }).catch(function (error) {
              console.log("Error cargando proerties", error);
            });
          },

          loadGlobals: function(redirect) {
            var app = this;

            if(typeof cordova != "undefined" && cordova.platformId && cordova.platformId != "electron") {
              FCM.getToken().then(token => {
                console.log("Get Token: " + token);
                Notificacion.registrarToken({data: {token: token}}).catch(e => {
                  console.log("Ha habido un error registrando token de las notificaciones, comuníquelo con el administrador, esto no tiene que ver para el funcionamiento de la aplicación.");
                });
              }).catch(e => {
                console.log("Ha habido un error conectando con el servidor de notificaciones, comuníquelo con el administrador, esto no tiene que ver para el funcionamiento de la aplicación.");
              });

              if (cordova.plugins && cordova.plugins.notification && cordova.plugins.notification.local) {
                cordova.plugins.notification.local.cancelAll((e) => console.log("CANCELALL", e) );
                let hour = this.methods.getRandomInt(1,6);
                let minute = this.methods.getRandomInt(0,59);
                cordova.plugins.notification.local.un('trigger', this.methods.onTriggerLocalNotification, this);
                cordova.plugins.notification.local.schedule({
                  title: 'Sincronización [0%]',
                  text: 'Sincronización automática de expedientes',
                  progressBar: { value: 0 },
                  trigger: { every: {hour: hour, minute: minute}, count: 365 },
                  autoClear: true
                });
                cordova.plugins.notification.local.on('trigger', this.methods.onTriggerLocalNotification, this);

              }
            } else {
              this.methods.loadProperties();
            }
            // [#65] La petición la hace `UsuarioActualizado`, que es quien sabe si el usuario de
            // esta carga ya está pedido: así las pantallas que esperan por él y este arranque no
            // preguntan dos veces ni se quedan cada uno con una respuesta. Guardar el usuario en
            // `app.data.user` y en localStorage lo hace también él.
            UsuarioActualizado.cargar({ forzar: true })
              .then(function() {
                if (redirect) {
                  app.methods.redirect();
                }
              })
              .catch(function(e) {
                console.log(e);
                app.toast
                  .create({
                    text: e.error_description,
                    position: "center",
                    closeTimeout: 2000
                  })
                  .open();
                if (e.error == "invalid_token") {
                  app.methods.removeSession();
                  var currentURL = app.views.main.router.currentRoute.path;
                  Flash.set("redirectTo", currentURL);
                  app.views.main.router.navigate("/login/");
                }
              });
          },
          redirect: function(){
            var app = this;
            var pathToGo = "/";
            var redirectTo = Flash.get("redirectTo");
            var directURL = Flash.get("directURL");
            app.views.left.router.navigate("/main-menu/");
            if(redirectTo){
              pathToGo = redirectTo;
            } else if (directURL) {
              var path = directURL.split("#!")[1];
              if (path) {
                pathToGo = path;
              } 
            }
            app.views.main.router.navigate(pathToGo);
          }
        },

        // App routes
        routes: routes,

        // Input settings
        input: {
          scrollIntoViewOnFocus:
            this.$device && this.$device.cordova && !this.$device.electron,
          scrollIntoViewCentered:
            this.$device && this.$device.cordova && !this.$device.electron
        },
        // Cordova Statusbar settings
        statusbar: {
          iosOverlaysWebView: true,
          androidOverlaysWebView: false
        },

        toast: {
          destroyOnClose: true
        },

        // Popup settings - Global configuration
        popup: {
          closeByBackdropClick: false
        },
      },
      Sugerencia,
      Notificacion,
      Global,
      currentRoute: ''
    };
  },
  methods: {
    _subscribeAiDocumentsEvents: function() {
      if (this._aiDocumentsHandler) {
        return;
      }
      this._aiDocumentsHandler = this._onAiDocumentEvent.bind(this);
      AiDocumentsEvents.subscribe(this._aiDocumentsHandler);
    },
    _unsubscribeAiDocumentsEvents: function() {
      if (this._aiDocumentsHandler) {
        AiDocumentsEvents.unsubscribe(this._aiDocumentsHandler);
        this._aiDocumentsHandler = null;
      }
    },
    _onAiDocumentEvent: function(payload) {
      if (!payload) {
        return;
      }
      const versionId = payload.version_id || payload.versionId || '';
      const indexedDoc = (payload.indexed && payload.indexed.document) || {};
      const titulo = indexedDoc.title || payload.title || versionId;
      if (payload.status === 'OK') {
        this._pushAiNotification({
          type: 'ok',
          title: 'Indexación completada',
          text: titulo || 'Documento'
        });
      } else if (payload.status === 'ERROR') {
        this._pushAiNotification({
          type: 'error',
          title: 'Error indexando',
          text: (titulo || 'documento') + (payload.error ? ' — ' + payload.error : '')
        });
      }
    },
    _pushAiNotification: function(notif) {
      const id = (this._aiNotifSeq = (this._aiNotifSeq || 0) + 1);
      this.aiNotifications.push({
        id: id,
        type: notif.type,
        title: notif.title,
        text: notif.text,
        hora: this._sello(new Date())
      });
    },
    /** Sello del aviso: hora (HH:MM:SS) y, si no es de hoy, también la fecha (DD/MM/YYYY). */
    _sello: function(d) {
      var hora = d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var hoy = new Date();
      var esHoy = d.getDate() === hoy.getDate() && d.getMonth() === hoy.getMonth() && d.getFullYear() === hoy.getFullYear();
      return esHoy ? hora : d.toLocaleDateString('es-ES') + ' ' + hora;
    },
    _dismissAiNotification: function(id) {
      const idx = this.aiNotifications.findIndex(function(n) { return n.id === id; });
      if (idx >= 0) {
        this.aiNotifications.splice(idx, 1);
      }
    },
    startVideo() {
      var self = this;
      let options = {
                    cameraDirection: CameraPreview.CAMERA_DIRECTION.BACK,
                    width: (window.screen.width/2),
                    height: (window.screen.height/2),
                    quality: 50,
                    withFlash: false
                  };
      CameraPreview.startRecordVideo(options,
                        (filePath) => {
                          console.log(filePath);
                          self.cameraRecording = true;    
                        },
                        (error) => {
                          console.log(error) ;
                          self.cameraRecording = false;   
                        },
      );
    },
    hacerFoto(callbackFn, extraParams, fotoYOtra = false) {
      var self = this;
      CameraPreview.takePicture(function(mediafiles) {
        console.log('[FOTO] Foto capturada:', mediafiles);
        callbackFn(mediafiles, extraParams);
        if (!fotoYOtra) {
          CameraPreview.stopCamera(_ => { self.cameraOpened = false; EventBus.$emit("cameraOpened", false); self.cameraRecording = false; self.cameraPhoto = false});
        }
      });
    },
    hacerVideo(callbackFn,extraParams) {
      var self = this;
      CameraPreview.stopRecordVideo((mediafiles) => {
        callbackFn([mediafiles],extraParams);
        CameraPreview.stopCamera(_ => { self.cameraOpened = false; EventBus.$emit("cameraOpened", false); self.cameraRecording = false; self.cameraPhoto = false});
      }, error => console.log(error));
    },
    cerrarCamara() {
      var self = this;
      // Limpiar los event listeners del pinch gesture
      self.removePinchGesture();
      CameraPreview.stopCamera(_ => { self.cameraOpened = false; EventBus.$emit("cameraOpened", false); self.cameraRecording = false; self.cameraPhoto = false });
      document.removeEventListener("backbutton", self.cerrarCamara, false);
    },
    openCameraForPhoto(callbackFn, extraParams) {
      const self = this;
      self.lastFotoCallback = callbackFn;
      self.lastFotoExtraParams = extraParams || {};

      // Resetear zoom y flash
      self.zoomLevel = 1;
      self.flashEnabled = false;

      CameraPreview.startCamera(
        {
          ...self.cameraPhotoOptions,
          x: 0,
          y: 0,
          width: window.screen.width,
          height: window.screen.height
        },
        _ => {
          // Detectar el zoom máximo del dispositivo
          self.detectMaxZoom();
          
          EventBus.$emit("cameraOpened", true);
          self.cameraOpened = true;
          self.cameraPhoto = true;
          self.cameraRecording = false;
          
          // Configurar el pinch-to-zoom con un pequeño delay para asegurar que el overlay esté renderizado
          setTimeout(() => {
            self.setupPinchGesture();
          }, 100);
          
          self.$refs.botonFoto.$el.onclick = _ => { self.hacerFoto(self.lastFotoCallback, self.lastFotoExtraParams, false); };
          self.$refs.botonFotoYOtra.$el.onclick = _ => { self.hacerFoto(self.lastFotoCallback, self.lastFotoExtraParams, true); };
        },
        err => {
          console.log("Error startCamera", err);
          CameraPreview.stopCamera(_ => { self.cameraOpened = false; EventBus.$emit("cameraOpened", false); self.cameraRecording = false });
        }
      );
    },
    detectMaxZoom() {
      const self = this;
      // Intentar obtener el zoom máximo del dispositivo
      if (typeof CameraPreview !== 'undefined' && CameraPreview.getMaxZoom) {
        CameraPreview.getMaxZoom((maxZoomLevel) => {
          console.log('Zoom máximo detectado:', maxZoomLevel);
          self.maxZoom = maxZoomLevel || 4;
          self.minZoom = CAMERA_MIN_ZOOM;
        }, (error) => {
          console.log('No se pudo detectar zoom máximo, usando valores por defecto:', error);
          self.maxZoom = 4;
          self.minZoom = CAMERA_MIN_ZOOM;
        });
      } else {
        // Fallback si el método no existe
        console.log('CameraPreview.getMaxZoom no disponible, usando valores por defecto');
        self.maxZoom = 4;
        self.minZoom = CAMERA_MIN_ZOOM;
      }
    },
    onZoomSliderChange() {
      const self = this;
      const currentZoom = parseFloat(self.zoomLevel);
      
      // Aplicar zoom cuando se mueve el slider
      CameraPreview.setZoom(currentZoom,
        () => {
          console.log('Zoom ajustado a:', self.zoomLevel);
        },
        (error) => {
          console.log('Error al ajustar zoom:', error);
        }
      );
    },
    capturarFoto(callbackFn, extraParams) {
      var self = this;
      self.openCameraForPhoto(callbackFn, extraParams);
      document.addEventListener("backbutton", self.cerrarCamara, false);
    },
    grabarVideo(callbackFn,extraParams) {
      var self = this;
      var app = self.$f7;
      CameraPreview.startCamera({ camera: "back", tapFocus: true, storeToFile: true, toBack: true }, 
        _ => {
          EventBus.$emit("cameraOpened", true);
          self.cameraOpened = true;
          self.cameraPhoto = false;
          self.cameraRecording = false;
          self.$refs.botonVideo.$el.onclick = _ => {self.hacerVideo(callbackFn,extraParams)};
        },
        _ => {
          CameraPreview.stopCamera(_ =>{self.cameraOpened = false; EventBus.$emit("cameraOpened", false); self.cameraRecording = false});
        }
      );
    },
    processNotification(data, app) {
      if (data.redirectUrl) {
        app.views.main.router.navigate(data.redirectUrl);
      } else if (data.redirectExternalUrl) {
        cordova.InAppBrowser.open(data.redirectExternalUrl, "_blank");
      }
    },
    sendSugerencia: function() {
      var self = this;
      var app = self.$f7;
      Sugerencia.post({
        data: { sugerencia: self.$refs.sugerenciaMejora.value }
      })
        .then(function(res) {
          self.$refs.sugerenciaMejora.value = "";
          if (self.$refs.popupSugerencia) {
            self.$refs.popupSugerencia.close(true);
          }
          app.dialog.alert("Gracias por su sugerencia, se ha realizado el envío correctamente.");
        })
        .catch(function(error) {
          var app = self.$f7;
          // si hay error mostrar mensaje vamos a mirar de que tipo es
          if (error.message) {
            if (error.message instanceof String) {
              app.dialog.alert(error.message);
            } else {
              app.dialog.alert(JSON.stringify(error.message));
            }
          } else {
            app.dialog.alert(
              "Ha habido un error enviando la sugerencia, por favor, inténtelo de nuevo más tarde."
            );
          }
        });
    },
    search: function(){
      var self = this,
        app = self.$f7;
        // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        Global.search(self.textoBusquedaGlobal).then(res=>{
          if (res.resultados && res.resultados.clientes){
            self.busquedaGlobal.clientes = res.resultados.clientes;
          }
          if (res.resultados && res.resultados.ofertas){
            self.busquedaGlobal.ofertas = res.resultados.ofertas;
          }
          if (res.resultados && res.resultados.pedidos){
            self.busquedaGlobal.pedidos = res.resultados.pedidos;
          }
          espera.cerrar();
          app.popup.open(self.$refs.popupBusquedaGlobal.$el);
          return res;
        }).catch(_=>espera.cerrar());
    },
    navega: function(tipo, elemento){
      const self = this,
        app = self.$f7;

      switch(tipo){
        case 'cliente':
          window.open("#!/clientes/view/" + elemento.id+"/", "_blank");
          break;
        case 'oferta':
          window.open("#!/ofertas/view/" + elemento.id+"/", "_blank");
          break;
        case 'pedido':
          window.open("#!/pedidos/view/" + elemento.id+"/", "_blank");
          break;
      }
      // app.popup.close(self.$refs.popupBusquedaGlobal.$el);
      self.textoBusquedaGlobal = "";
    },
    _getLokiops: function (f7, app) {
      const self = this;
      var lokiopts = {
        autoload: true,
        autoloadCallback: function() {
          self._loadPages(f7, app);
        } //Lokijs loaded
      };
      return lokiopts;
    },
    _loadPages: function (f7, app) {
      // TODO Ver como hacerlo mejor
      const actualPath = window.location.hash.replace("#!", "");
      if (!actualPath.startsWith("/public")) {
        app.methods.startSession();
      }
      var leftView = app.views.create(".view-left", {
        name: "left",
        routes: routesLeft,
        url: "/main-menu/"
      });
      var mainView = app.views.create(".view-main", {
        url: "/",
        preloadPreviousPage: false,
        pushState: f7.device.cordova ? false : true,
        xhrCache: false
      });
    },
    prepararFichaje: function() {
      self = this;
      // NOID crea fichajes en nombre de otros: no tiene sentido buscar su último
      // fichaje. Preparamos el popup vacío en modo rango (entrada+salida) y será
      // el operador quien rellene el empleado destino y las fechas.
      const esNoid = Utils.getUser() && Utils.getUser().username == 'NOID';
      if (esNoid) {
        self.lastFichaje = { tipoFichaje: 'ENTRADA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
        self.newFichaje = { tipoFichaje: 'SALIDA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
        self.fichajeRango = true;
        // Si la ruta actual es /calendario/<username>/ prerellenamos ese username.
        const matchCalendario = self.currentRoute && self.currentRoute.match(/^\/calendario\/([^\/]+)\/?$/);
        if (matchCalendario && matchCalendario[1]) {
          self.usernameFichajeNoid = matchCalendario[1];
        }
        return;
      }
      // Buscar el fichaje anterior para mostrarlo y saber si el actual es de entrada o de salida.
      if (self.fichajeRango) {
        self.lastFichaje = { tipoFichaje: 'ENTRADA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
        self.newFichaje = { tipoFichaje: 'SALIDA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
      } else {
        self.lastFichaje = Fichaje.findLast().then(function (res) {
          self.lastFichaje = res;
          // si no hay fichaje anterior o lastFichaje.tipoFichaje es SALIDA, el actual es de entrada
          if (!self.lastFichaje || self.lastFichaje.tipoFichaje === 'SALIDA') {
            self.newFichaje = { tipoFichaje: 'ENTRADA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
            return;
          }
          // En otro caso el actual es de salida
          else {
            self.newFichaje = { tipoFichaje: 'SALIDA', fechaHora: DateUtils.dateFormat(new Date(), 'YYYY-MM-DDTHH:mm') };
          }
        }).catch(function (e) {
          console.log(e);
        });
      }

    },
    getMinDate: function () {
      const self = this;
      if (self.fichajeRango) {
        return null;
      }
      return (self.lastFichaje && self.lastFichaje.fechaHora ? DateUtils.dateFormat(self.lastFichaje.fechaHora, 'YYYY-MM-DDTHH:mm') : undefined);
    },
    getDuracion: function() {
      const self = this;
      // calculamos la duración en minutos, la guardamos en newFichaje.duracion y la devolvemos
      if(self.newFichaje && self.newFichaje.tipoFichaje === 'SALIDA' && self.lastFichaje) {
        let diff = DateUtils.getDurationInMinutes(self.lastFichaje.fechaHora, self.newFichaje.fechaHora);
        self.newFichaje.duracion = diff;
        return DateUtils.getDurationInHoursAndMinutes(diff);
      }
    },
    changeDate: function(e, target) {
      const self = this;
      // Guardar el nuevo valor en el campo fechaHora del newFichaje
      self[target].fechaHora = e.target.value;
    },

    _guardarFichaje: async function () {
      const self = this;
      // Si está creando como NOID, exigimos que se haya seleccionado el empleado destino.
      const esNoid = Utils.getUser() && Utils.getUser().username == 'NOID';
      if (esNoid) {
        if (!self.usernameFichajeNoid) {
          self.$f7.dialog.alert('Selecciona el empleado destino del fichaje.');
          return;
        }
        if (self.newFichaje) {
          self.newFichaje.username = self.usernameFichajeNoid;
        }
        if (self.lastFichaje) {
          self.lastFichaje.username = self.usernameFichajeNoid;
        }
      }
      const previousFechaHoraNewFichaje = self.newFichaje.fechaHora;
      const previousFechaHoraLastFichaje = self.lastFichaje ? self.lastFichaje.fechaHora : null;
      // Convertimos la fechaHora a Date
      self.newFichaje.fechaHora = new Date(self.newFichaje.fechaHora);
      // Obtenemos la geolocalización
      let location = await Utils.executeTask(10000, self.getLocation(), null);
      self.newFichaje.location = location;

      if (self.fichajeRango) {
        // Convertimos la fechaHora a Date
        self.lastFichaje.fechaHora = new Date(self.lastFichaje.fechaHora);
        self.lastFichaje.location = location;
        Fichaje.saveRango({ data: {entrada: self.lastFichaje, salida: self.newFichaje} }).then(function (res) {
          self.lastFichaje = null;
          self.newFichaje = null;
          self.$refs.popupFichaje.close();
          EventBus.$emit("fichajeGuardado", res);
        }).catch(function (e) {
          self.$f7.dialog.alert(e.message);
        });
        if (self.lastFichaje) {
          self.lastFichaje.fechaHora = previousFechaHoraLastFichaje;
        }
      } else {
        Fichaje.save({ data: self.newFichaje }).then(function (res) {
          self.lastFichaje = null;
          self.newFichaje = null;
          self.$refs.popupFichaje.close();
          EventBus.$emit("fichajeGuardado", res);
        }).catch(function (e) {
          self.$f7.dialog.alert(e.message);
        });
      }
      if (self.newFichaje) {
        self.newFichaje.fechaHora = previousFechaHoraNewFichaje;
      }
    },
    guardarFichaje: async function() {
      const self = this;
      // Guardar el fichaje en la base de datos
      if (self.newFichaje) {
        if (self.lastFichaje && self.lastFichaje.tipoFichaje === 'ENTRADA') {
          // comprobamos si el enterior fichaje es de un día diferente para sacar un error
          if (DateUtils.dateFormat(self.lastFichaje.fechaHora, 'YYYY-MM-DD') !== DateUtils.dateFormat(self.newFichaje.fechaHora, 'YYYY-MM-DD')) {
            self.$f7.dialog.confirm(
              "El fichaje que está intentando registrar es de un día diferente de la entrada anterior, ¿Está seguro de que desea crear este fichaje?",
              "Advertencia",
              self._guardarFichaje,
            );
            return;
          }
        }
        self._guardarFichaje();
      }
    },
    async getLocation() {
      const self = this;
      let location = null;
      try {
        if (navigator && navigator.geolocation) {
          const pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 5000, enableHighAccuracy: true });
          });
          if (pos) {
            location = {
              punto: { coordinates: [pos.coords.longitude, pos.coords.latitude], type: "Point", x: pos.coords.longitude, y: pos.coords.latitude },
              latitud: pos.coords.latitude,
              longitud: pos.coords.longitude,
              direccion: pos.coords.longitude + ", " + pos.coords.latitude,
              fecha: new Date()
            };

            if (self.nominatim) {
              try {
                let nomClient = self.nominatim.default.createClient({ useragent: "SIMECAL-MOVILIDAD" });
                const res = await nomClient.reverse({lat: pos.coords.latitude, lon: pos.coords.longitude});
                location.direccion = res.display_name;
              } catch (e) {
                console.log("Error obteniendo direccion de nominatim: ", e);
              }
            }
          }
        }
      } catch (e) {
        console.log("Error obteniendo direccion de nominatim: ", e);
      } 
      return location;
    },
    updateCurrentRoute(route) {
      this.currentRoute = route;
    },
    onOrientationChange() {
      const self = this;
      console.log("Orientation changed");
      if (!self.cameraOpened) return;
      // pequeño delay para que el WebView termine de rotar
      self.removePinchGesture();
      setTimeout(() => {
        CameraPreview.stopCamera(() => {
          self.openCameraForPhoto(self.lastFotoCallback, self.lastFotoExtraParams);
        }, err => console.log("Error stopCamera en orientation change", err));
      }, 300);
    },
    toggleFlash() {
      const self = this;
      self.flashEnabled = !self.flashEnabled;
      CameraPreview.setFlashMode(self.flashEnabled ? 'on' : 'off',
        () => {
          console.log('Flash:', self.flashEnabled ? 'activado' : 'desactivado');
        },
        (error) => {
          console.log('Error al cambiar el flash:', error);
          self.flashEnabled = !self.flashEnabled;
        }
      );
    },
    getDistance(touch1, touch2) {
      // Calcula la distancia euclidiana entre dos puntos de toque
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    },
    onTouchStart(event) {
      const self = this;
      // Solo procesar si hay dos dedos tocando
      if (event.touches.length === 2) {
        self.isPinching = true;
        self.pinchStartDistance = self.getDistance(event.touches[0], event.touches[1]);
        self.pinchStartZoom = parseFloat(self.zoomLevel);
        console.log('Pinch iniciado. Distancia inicial:', self.pinchStartDistance, 'Zoom inicial:', self.pinchStartZoom);
        event.preventDefault();
        event.stopPropagation();
      }
      // Si solo hay un dedo, no hacer nada para que el toque pase a través
    },
    onTouchMove(event) {
      const self = this;
      // Solo procesar si estamos en un gesto de pinch
      if (!self.isPinching || event.touches.length !== 2) return;

      event.preventDefault();
      event.stopPropagation();
      
      const currentDistance = self.getDistance(event.touches[0], event.touches[1]);
      const ratio = currentDistance / self.pinchStartDistance;
      
      // Calcular el nuevo zoom basado en el ratio del gesto
      let newZoom = self.pinchStartZoom * ratio;
      
      // Limitar el zoom dentro de los rangos permitidos
      newZoom = Math.max(self.minZoom, Math.min(self.maxZoom, newZoom));
      newZoom = Math.round(newZoom * 10) / 10;
      
      self.zoomLevel = newZoom;
      console.log('Pinch en movimiento. Ratio:', ratio.toFixed(2), 'Nuevo zoom:', newZoom);
      
      // Aplicar zoom directamente
      if (window.CameraPreview) {
        CameraPreview.setZoom(self.zoomLevel);
      }
    },
    onTouchEnd(event) {
      const self = this;
      if (event.touches.length < 2) {
        console.log('Pinch finalizado. Zoom final:', self.zoomLevel);
        self.isPinching = false;
        // Activar pointer-events nuevamente después de un pequeño delay
        setTimeout(() => {
          // El binding reactivo ya actualizará la clase
        }, 50);
      }
    },
    setupPinchGesture() {
      const self = this;
      // Usar el overlay específico para capturar los gestos
      const pinchOverlay = self.$refs.cameraPinchOverlay;
      
      if (pinchOverlay && self.cameraOpened) {
        // Crear referencias a los handlers con el contexto correcto
        self._touchStartHandler = (e) => self.onTouchStart(e);
        self._touchMoveHandler = (e) => self.onTouchMove(e);
        self._touchEndHandler = (e) => self.onTouchEnd(e);
        
        // Usar passive: false para poder usar preventDefault en pinch
        pinchOverlay.addEventListener('touchstart', self._touchStartHandler, { passive: false });
        pinchOverlay.addEventListener('touchmove', self._touchMoveHandler, { passive: false });
        pinchOverlay.addEventListener('touchend', self._touchEndHandler, { passive: false });
        
        console.log('Pinch gesture listeners agregados al overlay');
      } else {
        console.log('ERROR: No se pudo agregar pinch gesture - overlay:', pinchOverlay, 'cameraOpened:', self.cameraOpened);
      }
    },
    removePinchGesture() {
      const self = this;
      const pinchOverlay = self.$refs.cameraPinchOverlay;
      
      if (pinchOverlay) {
        // Remover los listeners usando las referencias almacenadas
        if (self._touchStartHandler) {
          pinchOverlay.removeEventListener('touchstart', self._touchStartHandler);
        }
        if (self._touchMoveHandler) {
          pinchOverlay.removeEventListener('touchmove', self._touchMoveHandler);
        }
        if (self._touchEndHandler) {
          pinchOverlay.removeEventListener('touchend', self._touchEndHandler);
        }
        // Limpiar las referencias
        self._touchStartHandler = null;
        self._touchMoveHandler = null;
        self._touchEndHandler = null;
        
        console.log('Pinch gesture listeners removidos');
      }
    }
  },
  computed: {
    rutaCalendario: function() {
      const user = Utils.getUser();
      if (!user) {
        console.log('Sin usuario: '+this.currentRoute);
        return false;
      }
      console.log('Con usuario: '+this.currentRoute);
      // NOID puede fichar en nombre de cualquiera, así que los botones aparecen
      // en cualquier calendario, no solo en el suyo.
      if (user.username === 'NOID' && this.currentRoute && this.currentRoute.startsWith('/calendario/')) {
        return true;
      }
      return this.currentRoute === '/calendario/'
        || this.currentRoute === '/calendario/' + user.username + '/'
        || this.currentRoute === '/fichaje/';
    }
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.onOrientationChange);
    if (this._aiSessionOpenHandler) {
      EventBus.$off("app:session:open", this._aiSessionOpenHandler);
    }
    if (this._aiSessionCloseHandler) {
      EventBus.$off("app:session:close", this._aiSessionCloseHandler);
    }
    this._unsubscribeAiDocumentsEvents();
  },
  mounted() {
    const self = this;
    window.addEventListener('orientationchange', this.onOrientationChange);
    EventBus.$on("capturarFoto", this.capturarFoto);
    EventBus.$on("grabarVideo", this.grabarVideo);
    this._aiSessionOpenHandler = () => { this._subscribeAiDocumentsEvents(); EventosErrorEvents.start(self.$f7); };
    // Al cerrar sesión se cierra la conexión SSE única: es compartida por todos los canales y
    // ya no se cierra sola al desengancharse el último (antes cada canal tenía la suya), así
    // que sin esto quedaría viva con el token del usuario anterior.
    this._aiSessionCloseHandler = () => { this._unsubscribeAiDocumentsEvents(); EventosErrorEvents.stop(); SseHub.close(); };
    EventBus.$on("app:session:open", this._aiSessionOpenHandler);
    EventBus.$on("app:session:close", this._aiSessionCloseHandler);
    if (localStorage.getItem("session")) {
      this._subscribeAiDocumentsEvents();
      EventosErrorEvents.start(self.$f7);
    }
    EventBus.$on("cameraOpened", (val) => {
      const elsPopup = document.getElementsByClassName("popup-tablet-fullscreen");
      const els = document.getElementsByClassName("popup-backdrop");
      [].forEach.call(els, function (el) {
        if (val) {
          el.style['z-index'] = -1;
        } else {
          delete el.style['z-index'];
        }
      });
      [].forEach.call(elsPopup, function (el) {
        if (!val) {
          self.$nextTick(() => {
            el.classList.add("modal-in");
          })
        }
      });
    });
    this.$f7ready(f7 => {
      var self = this;
      // Init cordova APIs (see cordova-app.js)
      if (f7.device.cordova) {
        cordovaApp.init(f7);
      }
      // Call F7 APIs here
      var app = this.$f7;

      if (typeof cordova == "undefined") {
        // Init Database
        var loki = require("lokijs");
        // var LokiFsMobileAdapter = require("loki-cordova-fs-adapter");
        var lokiopts = self._getLokiops(f7, app);
        lokiopts.env = "BROWSER";
        window.db = new loki(app.data.appDataPath + "/simecal.json", lokiopts);
      } else if (cordova.platformId == "electron") {
        // Init Database
        var loki = require("lokijs");
        // var LokiFsMobileAdapter = require("loki-cordova-fs-adapter");
        var lokiopts = self._getLokiops(f7, app);
        lokiopts.adapter = new LokiFsAdapter();
        window.db = new loki(app.data.appDataPath + "/simecal.json", lokiopts);
      } else {
        self._loadPages(f7, app);
        window.db = window.plugins.mongodb;
        window.db.initiate("simecal-movilidad");
        // lokiopts.adapter = new LokiFsMobileAdapter({ prefix: "loki" });
        // window.db = new loki("simecal.db", lokiopts);

        FCM.getToken().then(token => {
          console.log("Get Token: " + token);
          Notificacion.registrarToken({data: {token: token}}).catch(e => {
            app.dialog.alert("Ha habido un error registrando token de las notificaciones, comuníquelo con el administrador, esto no tiene que ver para el funcionamiento de la aplicación.");
          });
        }).catch(e => {
          app.dialog.alert("Ha habido un error conectando con el servidor de notificaciones, comuníquelo con el administrador, esto no tiene que ver para el funcionamiento de la aplicación.");
        });
        FCM.onTokenRefresh((token) => {
          console.log("Token refresh: " + token);
          Notificacion.registrarToken({data: {token: token}}).catch(e => {
            app.dialog.alert("Ha habido un error registrando token de las notificaciones, comuníquelo con el administrador, esto no tiene que ver para el funcionamiento de la aplicación.");
          });
        });

        FCM.onNotification(function(data) {
          if(data.wasTapped) {
            //Notification was received on device tray and tapped by the user.
            console.log(data);
            self.processNotification(data, app);
          } else {
            //Notification was received in foreground. Maybe the user needs to be notified.
            console.log(data);
            app.dialog.confirm(data.body, data.title, (_) => {
              self.processNotification(data, app);
            });
          }
        });

        if (cordova && cordova.plugins && cordova.plugins.notification && cordova.plugins.notification.local) {
          cordova.plugins.notification.local.un('trigger', app.methods.onTriggerLocalNotification, app);
          cordova.plugins.notification.local.on('trigger', app.methods.onTriggerLocalNotification, app);
        }

      }
      window.app = app;

      //FIX external links inAppBrowser
      this.$$(this.$el).on("click", "a", function(e) {
        if (self.$$(this).hasClass("external")) {
          if (self.$$(this).hasClass("base64")) {
            if (typeof cordova == "undefined") {
              var link =
                '<iframe src="' +
                this.href +
                '" frameborder="0" style="margin:0; padding:0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>';
              var win = window.open();
              win.document.write(link);
            } else {
              var base64Data = this.href.split(',')[1];
              var data = FileUtils.b64toData(base64Data);
              FileUtils.openFile(data, this.dataset["name"], function() {}, function() {});
            }
          } else {
            var link = this.href;
            window.open(link, "_blank");
          }
          e.preventDefault();
          return false;
        }
      });
      // Escuchar el evento routeChange
      app.on('routeChange', (route) => {
        self.updateCurrentRoute(route.url.includes('#!')?route.url.split('#!')[1]:route.url);
      });
  
      // Inicializar la ruta currentRoute
      self.updateCurrentRoute(window.location.hash.replace("#!", ""));
    });

  }
};
</script>

<style>
/* AI document indexing notifications — custom stack, top-right */
.ai-notif-stack {
  position: fixed;
  top: 12px;
  right: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  z-index: 22000;
  pointer-events: none;
}
.ai-notif {
  pointer-events: auto;
  position: relative; /* ancla de la X flotante */
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 34px 10px 12px; /* hueco a la derecha para la X */
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
  min-width: 280px;
  max-width: min(640px, calc(100vw - 24px));
}
.ai-notif--ok {
  background: #2e7d32;
}
.ai-notif--error {
  background: #c62828;
}
.ai-notif-icon {
  flex-shrink: 0;
  font-size: 22px !important;
  line-height: 1.1;
  color: #fff;
}
.ai-notif-body {
  flex: 1;
  /* Sin esto, un contenido intrínsecamente ancho (JSON sin espacios) expande el flex-item
     más allá del max-width del aviso y desplaza el borde derecho real (y con él la X). */
  min-width: 0;
  max-width: 100%;
}
.ai-notif-title {
  white-space: nowrap;
  font-weight: 600;
  margin-bottom: 2px;
}
.ai-notif-time {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 400;
  opacity: 0.75;
  vertical-align: middle;
}
.ai-notif-text {
  /* Los mensajes largos (errores de indexado) envuelven en varias líneas: nunca
     generan scroll horizontal. Si son enormes, scroll vertical interno acotado. */
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-height: 30vh;
  overflow-y: auto;
  opacity: 0.95;
}
.ai-notif-close {
  /* X fija flotando en la esquina superior derecha del aviso, siempre visible
     aunque el contenido sea largo. */
  position: absolute;
  top: 6px;
  right: 6px;
  /* Respaldo por si el posicionado no aplica (HMR/caché): que el botón no se estire
     a todo el ancho y quede alineado a la derecha también en flujo normal. */
  width: auto;
  margin-left: auto;
  align-self: flex-start;
  flex-shrink: 0;
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  opacity: 0.8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.ai-notif-close:hover {
  opacity: 1;
}
.ai-notif-close i {
  font-size: 18px !important;
}
</style>
